<div class="mt-8 mb-4">

    <div class="flex justify-between items-center w-full mb-4">

        <div class="flex flex-row justify-between">
            <app-btn-back></app-btn-back>
        </div>

    </div>

    <div class="flex flex-col mb-4 border-0 w-full">

        <h1 class="font-semibold text-2xl text-primary-500">
            Live Quiz Room
        </h1>
        <span class="text-sm text-gray-500">Create a live quiz session and invite students to join in real-time</span>

        <div class="flex flex-col bg-white rounded-lg justify-start items-start p-4 mt-4">

            <div class="flex flex-row justify-between items-center w-full">
                <div class="flex flex-col">
                    <span class="text-lg font-semibold text-primary-500">Room Setup</span>
                    <div class="h-6 overflow-hidden">
                        @if (currentStep() === 0) {
                        <span class="block text-sm text-primary-300 animate-fade-in-up">
                            Prepare Questions
                        </span>
                        } @if (currentStep() === 1) {
                        <span class="block text-sm text-primary-300 animate-fade-in-up">
                            Configure Quiz Settings
                        </span>
                        }@else if (currentStep() === 2) {
                        <span class="block text-sm text-primary-300 animate-fade-in-up">
                            Invite Participants and Start Quiz
                        </span>
                        }
                    </div>
                </div>
                <div class="flex flex-row gap-2">
                    @if(currentStep() == 1) {
                    <app-btn-action icon="fas fa-chevron-left" textColor="text-primary-500" [shadow]="false"
                        textStyle="font-medium text-sm titlecase"
                        bgColor="bg-white hover:bg-gray-200 border border-gray-200" label="Previous"
                        (click)="changeStep(-1)"></app-btn-action>
                    }
                    @if(currentStep() == 0) {
                    <app-btn-action suffixIcon="fas fa-chevron-right" textColor="text-primary-500" [shadow]="false"
                        textStyle="font-medium text-sm titlecase"
                        bgColor="bg-white hover:bg-gray-200 border border-gray-200" label="Next"
                        (click)="changeStep(1)"></app-btn-action>
                    }
                    @if(currentStep() === 1) {
                    <app-btn-action suffixIcon="fa fa-chevron-right" textColor="text-primary-500" [shadow]="false"
                        textStyle="font-medium text-sm titlecase"
                        bgColor="bg-white hover:bg-gray-200 border border-gray-200" label="Create Room"
                        [isDisabled]="quizForm.invalid" [inProgress]="isWorking()"
                        (click)="createRoom()"></app-btn-action>
                    }
                </div>
            </div>
        </div>

        @if(currentStep() === 0) {
        <div class="flex flex-row flex-nowrap gap-4 mt-4 w-full">

            <div class="flex flex-col w-full rounded-lg">

                <div class="grid grid-cols-3 grid-rows-1 gap-4 text-center w-full items-center">
                    <div class="p-4 border border-gray-200 bg-white rounded-lg h-full w-full">
                        <p class="text-2xl font-bold text-primary-500">{{selectedQuestions().length}}</p>
                        <p class="text-xs text-slate-500 uppercase">Questions</p>
                    </div>
                    <div class="p-4 border border-gray-200 bg-white rounded-lg h-full w-full">
                        <p class="text-2xl font-bold text-primary-500">{{totalScore()}}</p>
                        <p class="text-xs text-slate-500 uppercase">Marks</p>
                    </div>
                    <div class="p-4 border border-gray-200 bg-white rounded-lg h-full w-full">
                        <p class="text-2xl font-bold text-red-500">{{quizForm.get('totalDuration')?.value ?? 0}} m
                        </p>
                        <p class="text-xs text-slate-500 uppercase">Duration</p>
                    </div>
                </div>

                <div class="flex flex-row justify-between items-center mt-4">
                    <div class="flex flex-col">
                        <span class="text-lg font-semibold text-primary-400">Selected Questions</span>
                        <span class="text-xs text-primary-300">Questions can also be added during session</span>
                    </div>
                    <span (click)="toggleSearch()"
                        class="text-sm cursor-pointer text-primary-300 hover:text-primary-500"><i
                            class="fa fa-add mr-1"></i> Add
                        Questions</span>
                </div>

                <div id="selectedListId" #selectedList="cdkDropList" cdkDropList [cdkDropListData]="selectedQuestions()"
                    (cdkDropListDropped)="drop($event)"
                    class="flex-1 overflow-y-auto touch-none flex flex-col gap-2 mt-2">
                    @for (item of selectedQuestions(); track item.id) {
                    <div class="flex flex-row items-start gap-2">
                        <div cdkDrag
                            class="flex flex-row gap-1 w-full bg-white border border-gray-200 p-2 rounded-md touch-none cursor-move shadow-sm hover:shadow-md transition-shadow">
                            <i class="fas fa-grip-vertical text-gray-400 self-start mt-1 mr-2"></i>
                            <div class="flex flex-col gap-2">
                                <span class="text-sm font-medium text-gray-700">{{ item.questionText }}</span>
                                <div class="flex flex-row gap-2">
                                    <app-chip [label]="item.questionType" [color]="chipColor.PRIMARY"></app-chip>
                                    <app-chip [label]="item.score + ' marks'" [color]="chipColor.LIGHT"></app-chip>
                                    <app-chip class="titlecase"
                                        [label]="item.reference.book + ' ' + item.reference.chapter + (item.reference.verse ? ':' + item.reference.verse : '')"
                                        [color]="chipColor.LIGHT"></app-chip>
                                </div>
                            </div>
                        </div>
                        <app-btn-fab (click)="removeQuestion(item)" bgColor="bg-transparent hover:bg-red-500"
                            textColor="text-red-500 hover:text-white" [icon]="'fas fa-trash'"></app-btn-fab>
                    </div>
                    }
                </div>
            </div>
        </div>
        }
        @else if(currentStep() === 1) {
        <div class="flex flex-col gap-4 mt-4 w-full">
            <div>
                <label class="form-label">Time per Question (seconds) *</label>
                <input type="number" min="0" max="60" [value]="quizForm.get('answerDuration')?.value"
                    (input)="setDuration($event)"
                    class="w-full p-2 border border-gray-200 rounded focus:ring-2 focus:ring-secondary-500">
            </div>
            <div>
                <label class="form-label">Quiz Title *</label>
                <input type="text" [value]="quizForm.get('title')?.value" (input)="setTitle($event)"
                    class="w-full p-2 border border-gray-200 rounded focus:ring-2 focus:ring-secondary-500">
            </div>
        </div>
        }
    </div>

    @if (showSearch) {
    <div class="fixed inset-0 z-50 flex" [class.items-end]="isMobile" [class.justify-end]="!isMobile">

        <div @fade (click)="toggleSearch()"
            class="absolute inset-0 bg-slate-900/40 backdrop-blur-sm transition-opacity">
        </div>

        <div [@slideInOut]="animationParams"
            class="relative bg-white shadow-2xl transition-all duration-300 overflow-hidden" [class.w-full]="isMobile"
            [class.h-[80vh]]="isMobile" [class.rounded-t-[32px]]="isMobile" [class.w-[550px]]="!isMobile"
            [class.h-full]="!isMobile">

            <div class="flex flex-col h-full w-full p-4">

                <span class="text-md font-semibold text-primary-400">Search & Add Questions</span>
                <span class="text-sm text-primary-300 mb-2">Search and add existing questions from your Question
                    Bank</span>

                <app-question-search [groupId]="groupId" [showTagsFilter]="true" [showTextFilter]="true"
                    (searchResults)="onSearchResults($event)" (searchCleared)="onSearchCleared()">
                </app-question-search>

                <div class="flex-1 overflow-y-auto touch-none flex flex-col gap-2">
                    @for (item of searchedQuestions$ | async; track item.id) {
                    <div class="flex flex-row items-start gap-2">
                        @let isSelected = isQuestionSelected(item.id);
                        <div (click)="toggleQuestion(item, !isSelected)"
                            class="flex flex-col gap-1 w-full p-2 rounded-md touch-none cursor-move shadow-sm border"
                            [class]="isSelected ? 'border-green-500 bg-green-100 hover:border-gray-200 hover:bg-gray-100' : 'bg-white border-gray-200 hover:bg-gray-100 hover:border-gray-200'">
                            <span class="text-sm font-medium text-gray-700">{{ item.questionText }}</span>
                            <div class="flex flex-row gap-2">
                                <app-chip [label]="item.questionType" [color]="chipColor.PRIMARY"></app-chip>
                                <app-chip [label]="item.score + ' marks'" [color]="chipColor.LIGHT"></app-chip>
                                <app-chip class="titlecase"
                                    [label]="item.reference.book + ' ' + item.reference.chapter + (item.reference.verse ? (':' + item.reference.verse) : '')"
                                    [color]="chipColor.LIGHT"></app-chip>
                            </div>
                        </div>
                    </div>
                    }
                </div>
            </div>
        </div>
    </div>
    }